import * as React from 'react';
import ttwLogo from "../../assets/ttw-logo.png";
import styles from './SyncFolder.module.css'
import Project from "../types/Project";
import ProjectMailFolder from "../types/ProjectMailFolder";

interface SyncFolderProps {
    projectMailFolder: ProjectMailFolder,
    trackProjectMailFolder: (folderId: string) => void,
    untrackProjectMailFolder: (folderId: string) => void
}

const SyncFolder = ({projectMailFolder, trackProjectMailFolder, untrackProjectMailFolder}: SyncFolderProps) => {
    const project = projectMailFolder.project;
    const folderId = projectMailFolder.id;

    const trackProjectItem = (project && !projectMailFolder.tracked) &&
        <div className={styles.fileJob} title="Track mail folder"
             onClick={() => {trackProjectMailFolder(folderId)}}>
            Track
        </div>

    const untrackProjectItem = (project && projectMailFolder.tracked) &&
        <div className={styles.fileJob} title="Untrack mail folder"
             onClick={() => {untrackProjectMailFolder(folderId)}}>
            Untrack
        </div>

    const projectItem = project &&
        <div className={styles.jobRowItem}>
            <a className={styles.jobLabel} title="Go to job emails" href={project.qualityUri} target="_blank">
                <span className={styles.jobNumber}>{project.number}</span>
                <span className={styles.jobName}>{project.name}</span>
            </a>
            {trackProjectItem}
            {untrackProjectItem}
        </div>;

    const noProjectItem = !project &&
        <div className={styles.jobRowItem}>
            None
        </div>;

    return (
        <div className={styles.container}>
            <div className={styles.label}>
                Selected Project Folder:
            </div>
            {projectItem}
            {noProjectItem}
        </div>
    )
};

export default SyncFolder;